import { Host, h } from "@stencil/core";
let id = 0;
export class CoreProgressIndicator {
    constructor() {
        this.progressindicatorId = `progress-indicator-${++id}`;
        this.renderLabel = () => {
            if (!this.hiddenLabel) {
                return (h("span", { id: `${this.progressindicatorId}-label`, class: "progress-indicator-label typography-heading-xsmall" }, this.label));
            }
        };
        this.renderDescription = () => {
            if (this.description && this.description !== '' && !this.hiddenLabel) {
                return h("span", { class: "progress-indicator-description typography-body-medium-regular" }, this.description);
            }
        };
        this.renderHeader = () => {
            if (!this.hiddenLabel) {
                return (h("div", { class: "progress-indicator-header" }, this.renderLabel(), this.renderDescription()));
            }
        };
        this.renderSteps = () => {
            if (this.total > 1 && this.total <= 9) {
                return [...Array(this.total).keys()].map(index => {
                    return h("div", { class: `progress-indicator-step ${this.getStepClasses(index + 1)}`, "aria-hidden": "true" });
                });
            }
            else {
                throw new Error(`${this.total} is not accepted in step property. Please provide a number > 1 and <= 9`);
            }
        };
        this.format = 'bar';
        this.label = undefined;
        this.hiddenLabel = false;
        this.description = undefined;
        this.progression = undefined;
        this.total = undefined;
        this.current = undefined;
        this.size = 'medium';
        this.internalProgressionValue = undefined;
        this.internalCurrentValue = undefined;
    }
    progressionChanged(newValue, oldValue) {
        if (this.format === 'fractions') {
            throw new Error('progression is not accepted on fractions format. Please use bar format instead');
        }
        if (newValue < 0 || newValue > 100) {
            throw new Error(`${newValue} is not accepted in progression property. Please provide a number >= 0 and <= 100`);
        }
        if (newValue !== oldValue) {
            this.internalProgressionValue = newValue;
        }
    }
    totalChanged() {
        if (this.format === 'fractions') {
            throw new Error('`total` is not accepted on bar format. Please use fractions format instead');
        }
        if (this.total < 3 || this.total > 9) {
            throw new Error(`${this.total} is not accepted in total property. Please provide a number >= 3 and < 9`);
        }
    }
    currentChanged(newValue, oldValue) {
        if (this.format === 'fractions') {
            throw new Error('current is not accepted on bar format. Please use fractions format instead');
        }
        if (newValue < 0 || newValue > this.total) {
            throw new Error(`${newValue} is not accepted in current property. Please provide a number >= 0 and <= total number`);
        }
        if (newValue !== oldValue) {
            this.internalCurrentValue = newValue;
        }
    }
    componentWillLoad() {
        if (this.progression && this.format === 'fractions') {
            throw new Error('progression is not accepted on fractions format. Please use bar format instead');
        }
        if (this.current && this.format === 'bar') {
            throw new Error('current is not accepted on bar format. Please use fractions format instead');
        }
        this.internalProgressionValue = this.progression;
        this.internalCurrentValue = this.current;
    }
    getStepClasses(index) {
        if (this.internalCurrentValue > index) {
            return 'progress-indicator-step--full';
        }
        else if (this.internalCurrentValue === index) {
            return 'progress-indicator-step--half';
        }
        else {
            return 'progress-indicator-step--empty';
        }
    }
    render() {
        return (h(Host, { key: '61a0150359c2fa38b0badb7b5189ba47b870cd11', class: "core-progress-indicator" }, this.format === 'fractions' && (h("div", { class: "progress-indicator-wrapper" }, this.renderHeader(), h("div", { "aria-label": this.hiddenLabel && this.label, "aria-value": this.internalCurrentValue, class: `progress-bar progress-bar-format--fractions progress-bar--${this.size}` }, this.renderSteps()))), this.format === 'bar' && (h("div", { class: "progress-indicator-wrapper" }, this.renderHeader(), h("div", { "aria-label": this.hiddenLabel && this.label, "aria-labelledby": !this.hiddenLabel && `${this.progressindicatorId}-label`, "aria-value": this.progression, class: `progress-bar progress-bar--${this.size}` }, h("div", { class: "progression-indicator", style: { width: `${this.internalProgressionValue === 0 ? 0 : Math.ceil(this.internalProgressionValue)}%` } }))))));
    }
    static get is() { return "core-progress-indicator"; }
    static get originalStyleUrls() {
        return {
            "$": ["core-progress-indicator.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["core-progress-indicator.css"]
        };
    }
    static get properties() {
        return {
            "format": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "ProgressionIndicatorTypes['format']",
                    "resolved": "\"bar\" | \"fractions\"",
                    "references": {
                        "ProgressionIndicatorTypes": {
                            "location": "local",
                            "path": "/Users/louismarcos/Documents/dev/core-designsystem/src/components/core-progress-indicator/core-progress-indicator.tsx",
                            "id": "src/components/core-progress-indicator/core-progress-indicator.tsx::ProgressionIndicatorTypes"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Format of the progress indicator."
                },
                "attribute": "format",
                "reflect": false,
                "defaultValue": "'bar'"
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "ProgressionIndicatorTypes['label']",
                    "resolved": "string",
                    "references": {
                        "ProgressionIndicatorTypes": {
                            "location": "local",
                            "path": "/Users/louismarcos/Documents/dev/core-designsystem/src/components/core-progress-indicator/core-progress-indicator.tsx",
                            "id": "src/components/core-progress-indicator/core-progress-indicator.tsx::ProgressionIndicatorTypes"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Label of the progress indicator."
                },
                "attribute": "label",
                "reflect": false
            },
            "hiddenLabel": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "ProgressionIndicatorTypes['hiddenLabel']",
                    "resolved": "boolean",
                    "references": {
                        "ProgressionIndicatorTypes": {
                            "location": "local",
                            "path": "/Users/louismarcos/Documents/dev/core-designsystem/src/components/core-progress-indicator/core-progress-indicator.tsx",
                            "id": "src/components/core-progress-indicator/core-progress-indicator.tsx::ProgressionIndicatorTypes"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Hide the label from the top of the progress indicator."
                },
                "attribute": "hidden-label",
                "reflect": false,
                "defaultValue": "false"
            },
            "description": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "ProgressionIndicatorTypes['description']",
                    "resolved": "string",
                    "references": {
                        "ProgressionIndicatorTypes": {
                            "location": "local",
                            "path": "/Users/louismarcos/Documents/dev/core-designsystem/src/components/core-progress-indicator/core-progress-indicator.tsx",
                            "id": "src/components/core-progress-indicator/core-progress-indicator.tsx::ProgressionIndicatorTypes"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Description of the progress indicator."
                },
                "attribute": "description",
                "reflect": false
            },
            "progression": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "ProgressionIndicatorTypes['progression']",
                    "resolved": "number",
                    "references": {
                        "ProgressionIndicatorTypes": {
                            "location": "local",
                            "path": "/Users/louismarcos/Documents/dev/core-designsystem/src/components/core-progress-indicator/core-progress-indicator.tsx",
                            "id": "src/components/core-progress-indicator/core-progress-indicator.tsx::ProgressionIndicatorTypes"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "The progression value in the `bar` format.\nIt is a percentage representation so it should be from 0 to 100."
                },
                "attribute": "progression",
                "reflect": false
            },
            "total": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "ProgressionIndicatorTypes['total']",
                    "resolved": "3 | 4 | 5 | 6 | 7 | 8 | 9",
                    "references": {
                        "ProgressionIndicatorTypes": {
                            "location": "local",
                            "path": "/Users/louismarcos/Documents/dev/core-designsystem/src/components/core-progress-indicator/core-progress-indicator.tsx",
                            "id": "src/components/core-progress-indicator/core-progress-indicator.tsx::ProgressionIndicatorTypes"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "The number of step in the `fractions` format.\nThe minimum of step should be 3 and the maximum should be 9."
                },
                "attribute": "total",
                "reflect": false
            },
            "current": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "ProgressionIndicatorTypes['current']",
                    "resolved": "number",
                    "references": {
                        "ProgressionIndicatorTypes": {
                            "location": "local",
                            "path": "/Users/louismarcos/Documents/dev/core-designsystem/src/components/core-progress-indicator/core-progress-indicator.tsx",
                            "id": "src/components/core-progress-indicator/core-progress-indicator.tsx::ProgressionIndicatorTypes"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "The current step number in the `fractions` format."
                },
                "attribute": "current",
                "reflect": false
            },
            "size": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "ProgressionIndicatorTypes['size']",
                    "resolved": "\"large\" | \"medium\" | \"small\"",
                    "references": {
                        "ProgressionIndicatorTypes": {
                            "location": "local",
                            "path": "/Users/louismarcos/Documents/dev/core-designsystem/src/components/core-progress-indicator/core-progress-indicator.tsx",
                            "id": "src/components/core-progress-indicator/core-progress-indicator.tsx::ProgressionIndicatorTypes"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "The size of the progress indicator."
                },
                "attribute": "size",
                "reflect": false,
                "defaultValue": "'medium'"
            }
        };
    }
    static get states() {
        return {
            "internalProgressionValue": {},
            "internalCurrentValue": {}
        };
    }
    static get watchers() {
        return [{
                "propName": "progression",
                "methodName": "progressionChanged"
            }, {
                "propName": "total",
                "methodName": "totalChanged"
            }, {
                "propName": "current",
                "methodName": "currentChanged"
            }];
    }
}
//# sourceMappingURL=core-progress-indicator.js.map
